export default {
  // loadingProfiles: false,
  // profiles: [],
  // chatProfiles: [],
  // notificationsProfiles: [],
  // failedProfileIds: [],
  /**
   * Profile Previews is refreshing
   * @prop {boolean} profilePreviewsLoading
   */
  profilePreviewsLoading: false,
  /**
   * @prop {Object[]} profilePreviews - as array of objects returned from backend.
   * @prop {string} profilePreviews[].firstName - first name
   * @prop {string} profilePreviews[].lastName - last name
   * @prop {string} profilePreviews[].fullName - full name
   * @prop {string} profilePreviews[].nick - nick
   * @prop {boolean} profilePreviews[].isActive - is active
   * @prop {boolean} profilePreviews[].processingMedia - is thumbnail still processing
   * @prop {string} profilePreviews[].thumbnailUrl - thumbnail url
   * @prop {string} profilePreviews[].uuid - uuid
   * @prop {number} profilePreviews[].profileId - profile id
   * @prop {number} profilePreviews[].userId - user id
   * @prop {number} profilePreviews[].roleId - role id
   * @prop {boolean | undefined | null } profilePreviews[].journalAvailable - journal available
   */
  profilePreviews: [],
  /**
   * @prop {Object[]} profilePreviewsQueue - as array of objects with min one prop: uuid or profileId
   * @prop {string | undefined | null} profilePreviewsQueue[].uuid - uuid
   * @prop {number | undefined | null} profilePreviewsQueue[].profileId - profile id
   */
  profilePreviewsQueue: [],
}
